import * as React from "react";
import Layout from "../../components/layout";
import HSCResults2025Content from "../../components/education/HSCResults2025Content";
import heroImage from "../../assets/education/hsc2025resultscrop.png";
import BannerImage from "../../components/master/BannerImage";

const HSCResults2024Page = () => {
  return (
    <Layout>
      <BannerImage imagePath={heroImage} altText="HSC Results 2025"  />
        <HSCResults2025Content />
    </Layout>
  );
};

export default HSCResults2024Page;
